import { render, staticRenderFns } from "./c_search_box.vue?vue&type=template&id=dc81c974&scoped=true"
import script from "./c_search_box.vue?vue&type=script&lang=js"
export * from "./c_search_box.vue?vue&type=script&lang=js"
import style0 from "./c_search_box.vue?vue&type=style&index=0&id=dc81c974&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81c974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc81c974')) {
      api.createRecord('dc81c974', component.options)
    } else {
      api.reload('dc81c974', component.options)
    }
    module.hot.accept("./c_search_box.vue?vue&type=template&id=dc81c974&scoped=true", function () {
      api.rerender('dc81c974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_search_box.vue"
export default component.exports